import React, {useContext, useEffect, useState} from "react";
import {
  LinkButton,
  Button,
  Wrapper,
  Container,
  LogoWrapper,
  Heading,
  SubHeading,
  OfferSection,
  Offer,
  Input,
  Divider,
  BlurImage,
  QRCodeBlock,
  QRCode,
  ShowPassword,
} from "./SignInOutForm.style";
import { AuthContext } from "../../contexts/auth/auth.context";
import { FormattedMessage } from "react-intl";
import Modal from "react-bootstrap/Modal";
// import Image from 'components/Image/Image';
// import PickBazar from '../../image/PickBazar.png';
import { connect, useSelector } from "react-redux";
import { doLogin, resetmessages, queryQRCodeSession } from "../../store/actions/authAction";
import Loader from "../../components/Loader/Loader";
import * as Constants from "../../constants/Constant";
import axios from "axios";
import history from "../../services/history";
import t from '../../i18n/translate';
import reactStringReplace from 'react-string-replace';
import { Collapse, Fade, Image, Spinner, Tab, Tabs } from "react-bootstrap";
import { Email, Smartphone, Visibility, VisibilityOff } from "@material-ui/icons";
import ReCAPTCHA from "react-google-recaptcha";
import Animation from "react-lottie";
import anim from "../../assets/icons/success-tick.json";
import { QRCodeCanvas } from 'qrcode.react';
import CloudflareTurnstile from "../../components/CloudflareTurnstile";


const lang = localStorage.getItem("lang");

const signUpLinkStyle = {
  color: "#9cc54b",
  textDecoration: "underline",
  fontWeight: "700",
  cursor: "pointer",
  marginLeft: 5
};

const SignInModal = (props) => {
  const { authDispatch } = useContext(AuthContext);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const [cerror, setCError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [authType, setAuthType] = React.useState("phone");
  const [firebaseToken, setFirebaseToken] = React.useState(localStorage.getItem('firebaseToken'));
  const [recaptcha, setRecaptcha] = React.useState(1);
  const [loginFade, setLoginFade] = React.useState(true);
  const [recaptchaLoding, setRecaptchaLoding] = React.useState(false);
  const [qrcodelink, setQRCodelink] = React.useState('');
  const [recaptchatoken, setRecaptchatoken] = React.useState('');
  const [qrcodeexpired, setQRcodeexpired] = React.useState(false);
  const [qrcodeCountdown, setQRcodeCountdown] = React.useState(30 +'s');
  const recaptchatokenref = React.useRef(null);
  const [showPassword, setShowPassword] = React.useState(false);
  const [token, setToken] = useState(null);
  const cartType = useSelector(state => state.cartReducer.cartType);
  const toggleSignUpForm = () => {
    authDispatch({
      type: "SIGNUP",
    });
  };

  const toggleForgotPassForm = () => {
    authDispatch({
      type: "FORGOTPASS",
    });
  };

  const didLoginFail = () => {
    if(!props.success){
      setCError(true);
    }
    setLoading(false);
  };

  const loginCallback = (e) => {
    e.preventDefault();
    if (!error) {
      setLoading(true);
      props.doLogin({ identifier: email, password: password, firebaseToken: firebaseToken });
      setTimeout(() => {
        didLoginFail();
      }, 2000);
    }
  };
  useEffect(()=>{
    if(window.location.pathname === "/register"){
      authDispatch({
        type: "SIGNUP",
      })
    }
  },[]);
  useEffect(() => {
    if (props.success) {
      // if(props.loginresponsemsg === "Your account is not verified yet. We have sent you an email for verification. Please check your inbox or spam."){
      //   alert("Your account is not verified yet. We have sent you an email for verification. Please check your inbox or spam.");
      // }
      setLoading(false);
      setCError(false);
      // authDispatch({ type: "SIGNIN_SUCCESS" });
    }
  }, [props.success, props.loginresponsemsg]);

  const linkToSignUpComponent = (e) => {
    e.preventDefault();
    authDispatch({type: "SIGNUP",});
  }

  const findUserByEmailOrPhone = (identifier) => {
    axios
      .post(Constants.baseUrl + `api/checkUserExistByEmailOrPhone?_locale=${lang}`, {
        identifier: identifier,
      })
      .then(function (response) {
        if (response.data.status === 2) {
          const errorAccountNotExistTran = t('login_error_account_not_exist_label', false);
          const errorEmailTranReplace = reactStringReplace(`${errorAccountNotExistTran}`, /({path})/g, () =>
            <span onClick={(e) => { linkToSignUpComponent(e); }} style={{...signUpLinkStyle, color:  props.cartType === 'express' ? "#f01266" : "#9cc54b"} }>
              {t('login_enter_email_to_register_redirection_label')}
            </span>
          );
          setError(true);
          setErrorMsg(errorEmailTranReplace);
          return false;
        }
        else {
          setError(false);
          setErrorMsg("");
          return true;
        }
      })
      .catch(function (error) {
        console.log(error);
        if(error?.response?.data){
          setError(true);
          setErrorMsg(error.response.data?.message);
          return false;
        }
      });
  }

  const validateEmail = async () => {
    if (!email) {
      const errorEmailTran = authType === "email" ? t('login_error_enter_an_email_label', false) : t('login_error_enter_a_phone_label', false);
      const errorEmailTranReplace = reactStringReplace(`${errorEmailTran}`, /({path})/g, () =>
        <span onClick={(e) => { linkToSignUpComponent(e) }} style={{...signUpLinkStyle, color:  props.cartType === 'express' ? "#f01266" : "#9cc54b"}}>
          { t('login_enter_email_to_register_redirection_label') }
        </span>
      );
      setErrorMsg(errorEmailTranReplace);

      setError(true);
      return false;
    }
    // else if ((Constants.email_reg.test(email)) === false) {
    //   setErrorMsg(t('login_error_incorrect_email'));
    //   setError(true);
    //   return false;
    // }
    else {
      if (authType === "phone") {
        if (/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(email) === false) {
          setError(true);
          setErrorMsg(t('login_error_incorrect_phone'));
        } else {
          setError(false);
          setErrorMsg("");
          findUserByEmailOrPhone(email);
        }
      } else {
        if ((Constants.email_reg.test(email)) === false) {
          setErrorMsg(t('login_error_incorrect_email'));
          setError(true);
        } else {
          setError(false);
          setErrorMsg("");
          findUserByEmailOrPhone(email);
        }
      }
      // setError(false);
    }
    // if ((await Constants.email_reg.test(email)) === false || !email || email === "") {
    //   setError(true);
    // } else {
    //   setError(false);
    // }
  };

  const handleSelectTab = (e) => {
    setAuthType(e);
    setEmail("");
    setPassword("");
    setError(false);
    setErrorMsg("");
    setCError(false);
  };

  useEffect(() => {
    props.resetmessages()
  }, [])

  // qrcode
  const switchModalForQRCode = () => {
    // first click, close login and send to captcha
    // otherwise back to login
    if(recaptcha === 1) {
      setLoginFade(!loginFade);
      setQRcodeexpired(false);
    }
    else setRecaptcha(1);
    clearInterval(querysessionInterval);
    clearInterval(qrcountdown);
  }

  const refreshQRCode = () => {
    setRecaptcha(2);
    setQRcodeexpired(false);
    clearInterval(querysessionInterval);
    clearInterval(qrcountdown);
  }

  const moveToQRCode = (token) => {
    setQRcodeexpired(false);
    setToken(token);
    setQRcodeCountdown(30 + 's');
    setRecaptchatoken(token);
    // settimeout for recaptcha animation
    setTimeout(() => {
      setLoginFade(!loginFade);
    }, 1000);
  }

  const fadeRecaptcha = () => {
    // change fade to normal
    setLoginFade(!loginFade);
    if(recaptcha === 1) setRecaptcha(2);
    if(recaptcha === 2) setRecaptcha(3);
    if(recaptcha === 3) setRecaptcha(1);
  }

  let time = 30;
  let qrcountdown;
  let querysessionInterval;
  const countdownQRExpired = () => {
    time -= 1;
    if(time === 0) {
      time = 'Expired';
      setQRcodeCountdown(time);
    } else {
      setQRcodeCountdown(time + 's');
    }
  }

  useEffect(() => {

    if(recaptcha === 3) {
    
      const getQRCode = (token) => {
        axios
          .post(Constants.baseUrl + "api/v2/qrCodePreCheck", {
            recaptchatoken: token
          })
          .then(function (response) {
            if (response.data.status === 2) {
              setError(true);
              return false;
            }
            else {
              setError(false);

              // Generate the QR code using the library
              setQRCodelink(response.data.hash);

              querysessionInterval = setInterval(() => {
                props.queryQRCodeSession({token: response.data.hash});
              }, 3000);
              qrcountdown = setInterval(countdownQRExpired, 1000);
              setTimeout(() => {
                clearInterval(querysessionInterval);
                clearInterval(qrcountdown);
                setQRcodeexpired(true);
              }, 30000);
              return true;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      if(recaptcha === 3) {
        getQRCode(token);
      };
    }
  }, [recaptcha,token])

  if(props.success) {
    setTimeout(() => {
      window.location.reload();
    }, 5000);
  }

  const defaultOptions = {
    speed: 1.5,
    loop: false,
    autoplay: true,
    animationData: anim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }

  return (
    <Wrapper style={{ overflow: "hidden" }}>
      <Container >
        {/* <LogoWrapper>
          <Image url={PickBazar} />
        </LogoWrapper> */}

        <Heading className={props.cartType}>
          { t('login_welcome_back_label') }
        </Heading>

        <SubHeading>
          { t('login_login_here_label') }
        </SubHeading>
        {
          (() => {
            if(recaptcha === 1) {
              return (
                <Fade in={loginFade} onExited={fadeRecaptcha}>
                  <form onSubmit={loginCallback}>
                    <Tabs defaultActiveKey="phone" id="sign-in-tab" className={`${props.cartType === "express" ? "express" : ""}`} justify onSelect={(e) => handleSelectTab(e)}>
                      <Tab eventKey="phone" title={<div className="d-flex align-items-center justify-content-center"><Smartphone className="mr-1" />{t("auth_type_phone_title")}</div>}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                          <Input
                            key="phone"
                            name="phone"
                            type="text"
                            placeholder={ t('login_input_phone_title', false) }
                            value={email}
                            className={props.cartType}
                            onChange={(e) => setEmail(e.target.value)}
                            onBlur={validateEmail}
                            required
                          />
                          <div className="position-relative">
                            <Input
                              key="phone-pass"
                              name="phone-pass"
                              type={showPassword ? "text" : "password"}
                              placeholder={ t('login_input_password_title', false) }
                              value={password}
                              className={props.cartType}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                              <ShowPassword className={cartType} variant="outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                              </ShowPassword>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="email" title={<div className="d-flex align-items-center justify-content-center"><Email className="mr-1" />{t("auth_type_email_title")}</div>}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                          <Input
                            key="email"
                            name="email"
                            type="text"
                            placeholder={ t('login_input_email_title', false) }
                            value={email}
                            className={props.cartType}
                            onChange={(e) => setEmail(e.target.value)}
                            onBlur={validateEmail}
                            required
                          />
                          <div className="position-relative">
                            <Input
                              key="email-pass"
                              name="email-pass"
                              type={showPassword ? "text" : "password"}
                              placeholder={ t('login_input_password_title', false) }
                              value={password}
                              className={props.cartType}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                            <ShowPassword className={cartType} variant="outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </ShowPassword>
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                    <Button
                      fullwidth
                      title={ t('login_button_login', false) }
                      intlButtonId="continueBtn"
                      type="submit"
                      style={{ color: "#fff", fontWeight: "normal", fontSize: '1rem', marginTop: "10px" }}
                      disabled={loading}
                      loader={<Loader />}
                      isLoading={loading}
                    />
                    {errorMsg !== ""
                      ? <span style={{color: "red", display: "block", marginTop: 10}}>{errorMsg}</span>
                      : null
                    }
                    {cerror && props.loginresponsemsg === "invalid password" ? <span className="text-danger">
                      { t('login_error_wrong_password_label') } { t('common_or_label') } <span onClick={(e) => {
                        e.preventDefault();
                        authDispatch({
                          type: "FORGOTPASS",
                        });
                        }} 
                        style={{color: props.cartType === 'express' ? "#f01266" : "#9cc54b", textDecoration: "underline", fontWeight: "700", cursor: "pointer"}}>{ t('login_button_forgot_password_reset_link') }</span></span> : null}
                    {cerror && props.loginresponsemsg !== "" && props.loginresponsemsg !== "invalid password"
                      ? <span className="text-success" style={{fontWeight: "700"}}>{ t('login_error_password', false) }</span>
                      : null
                    }
                  </form>
                </Fade>
              )
            } else if(recaptcha === 2) {
              return (<>
                <Fade in={loginFade} onExited={fadeRecaptcha}>
                  {/*<ReCAPTCHA*/}
                  {/*  asyncScriptOnLoad={() => setRecaptchaLoding(false)}*/}
                  {/*  sitekey={Constants.captchaKey}*/}
                  {/*  ref={recaptchatokenref}*/}
                  {/*  onChange={moveToQRCode}*/}
                  {/*/>*/}
                  <div className={"d-flex"} style={{backgroundColor:"#ffffff"}}>
                    <CloudflareTurnstile
                        sitekey={Constants.sitekey}
                        onVerify={(token) => moveToQRCode(token)}
                        onError={(error) => console.log(error)}
                        className="turnstile-widget"
                        style={{ backdropColor:"#ffffff" }}
                    />
                  </div>
                </Fade>
              </>)
            } else if(recaptcha === 3) {
              return (<>
                <Fade in={loginFade} onExited={fadeRecaptcha}>
                  <>
                  {
                    (() => {
                      if(!props.success && qrcodeexpired) { // blur qr code when expired
                        return (
                          <QRCodeBlock>
                            <BlurImage>
                              <QRCode>
                                <div>
                                  <span className="scan-code__angle scan-code__angle--top"></span>
                                  {/* <Image src={qrcodelink} style={{ marginTop: '-30px', scale: "80%"}} width={300} height={300}/> */}
                                  <QRCodeCanvas value={qrcodelink} size={256} level="H" includeMargin={true} />
                                  <span className="scan-code__angle scan-code__angle--bottom"></span>
                                </div>
                              </QRCode>
                            </BlurImage>
                            <Button
                              title={ t('login_qrcode_refresh', false) }
                              intlButtonId="refreshBtn"
                              type="button"
                              style={{ background: "#ebebeb", color: "#000", fontWeight: "normal", fontSize: '1rem', marginTop: "-10px" }}
                              onClick={refreshQRCode}
                            />
                          </QRCodeBlock>
                        )
                      } else if(!props.success && !qrcodeexpired) { // show qrcode
                        return (
                          <QRCode>
                            <div>
                              <span className="scan-code__angle scan-code__angle--top"></span>
                              {/* <Image src={qrcodelink} style={{ marginTop: '-30px', scale: "80%"}} width={300} height={300}/> */}
                              <QRCodeCanvas value={qrcodelink} size={256} level="H" includeMargin={true} />
                              <span className="scan-code__angle scan-code__angle--bottom"></span>
                            </div>
                          </QRCode>
                        )
                      } else if(props.success) { // show animation of successful login
                        return (
                          <QRCodeBlock>
                            <BlurImage>
                              <QRCode>
                                <div>
                                  <span className="scan-code__angle scan-code__angle--top"></span>
                                  {/* <Image src={qrcodelink} style={{ marginTop: '-30px', scale: "80%"}} width={300} height={300}/> */}
                                  <QRCodeCanvas value={qrcodelink} size={256} level="H" includeMargin={true} />
                                  <span className="scan-code__angle scan-code__angle--bottom"></span>
                                </div>
                              </QRCode>
                            </BlurImage>
                            <div className="tick-sign">
                              <Animation options={defaultOptions} height={100} width={100} />
                            </div>
                          </QRCodeBlock>
                        )
                      }
                    })()
                  }
                  <Offer>
                    <div className="count-down">{ qrcodeCountdown }</div>
                  </Offer>
                  <Offer>{ t('login_with_qrcode_text') }</Offer>
                  </>
                </Fade>
              </>
              )
            }
          })()
        }
        <Button
          fullwidth
          title={ recaptcha === 1 ? t('login_with_qrcode', false) : t('login_qrcode_back', false) }
          intlButtonId="loginqrcodeBtn"
          type="button"
          style={{ background: "#ebebeb", color: "#000", fontWeight: "normal", fontSize: '1rem', marginTop: "10px" }}
          // disabled={loading}
          loader={<Loader />}
          onClick={switchModalForQRCode}
          // isLoading={loading}
        />
        <Divider>
          <span>
            { t('common_or_label') }
          </span>
        </Divider>

        <Offer style={{ padding: "20px 0" }}>
          { t('login_dont_have_account_description') }{" "}
          <LinkButton className={props.cartType} onClick={toggleSignUpForm}>
            { t('login_button_sign_up') }
          </LinkButton>
        </Offer>
      </Container>

      <OfferSection>
        <Offer className={props.cartType}>
          { t('login_forgot_password_label') }{" "}
          <LinkButton className={props.cartType} onClick={toggleForgotPassForm}>
            { t('login_button_forgot_password_reset_link') }
          </LinkButton>
        </Offer>
      </OfferSection>
    </Wrapper>
  );
};
const mapStateToProps = (state) => {
  return {
    payload: state.authReducer.payload,
    success: state.authReducer.success,
    loginresponsemsg: state.authReducer.loginresponsemsg,
    cartType: state.cartReducer.cartType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doLogin: (body) => doLogin(body, dispatch),
    queryQRCodeSession: (body) => queryQRCodeSession(body, dispatch),
    resetmessages: () => resetmessages(dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignInModal);
